module.exports = __webpack_public_path__ + "img/hts2.eaa5098a.png";